import LineRegisterStart from "./LineRegisterStart";

export default function LineLoginPage() {
  return (
    <LineRegisterStart
      autoStart
      entrySource="webApp"
      description="LINEでWizMateにサインインします"
      startButtonLabel="LINEでサインイン"
      loadingMessage="LINEを開いています..."
    />
  );
}
